import { create } from "zustand";
import { currentActiveChatbotThreadTypeNew, voiceCallActionExecutionData, VoiceCallDetails } from "../models/axiosModel";

export interface wabaDetailsInterface {
    waba_name: string;
    phone_number: string;
    phone_number_id: string;
}

interface voiceCallStoreInterface {
    isVoiceCallingEnableWaba: boolean,
    setIsVoiceCallingEnableWaba: (value: boolean) => void,

    flagVoiceCallPopup: boolean,
    setFlagVoiceCallPopup: (value: boolean) => void,

    flagVoiceCallInboundPopup: boolean,
    setFlagVoiceCallInboundPopup: (value: boolean) => void,

    flagInboundCallNotification: boolean,
    setFlagInboundCallNotification: (value: boolean) => void,

    callingWabaDetails: wabaDetailsInterface | null,
    setCallingWabaDetails: (value: wabaDetailsInterface | null) => void,

    callingPersonDetails: currentActiveChatbotThreadTypeNew | null,
    setCallingPersonDetails: (value: currentActiveChatbotThreadTypeNew | null) => void,

    inboundCallExecutionData: voiceCallActionExecutionData | null,
    setInboundCallExecutionData: (value: voiceCallActionExecutionData | null) => void,

    voiceCallDetails: VoiceCallDetails | null,
    setVoiceCallDetails: (value: VoiceCallDetails | null) => void,

    flagAutoAcceptInboundCall: boolean,
    setFlagAutoAcceptInboundCall: (value: boolean) => void,

    isCallConnected: boolean,
    setIsCallConnected: (value: boolean) => void,

    voiceCallId: string,
    setVoiceCallId: (value: string) => void,

    isCalling: boolean,
    setIsCalling: (value: boolean) => void,

    callDuration: number,
    setCallDuration: (value: number) => void,

    timerIntervalTimeout: NodeJS.Timeout | null,
    setTimerIntervalTimeout: (value: NodeJS.Timeout | null) => void,

    callStartTimeRef: number | null,
    setCallStartTimeRef: (value: number | null) => void,

    startCallTimer: () => void,
    stopCallTimer: () => void,

    showInboundCallNotification: (payload: {
        callData: currentActiveChatbotThreadTypeNew,
        executionData: voiceCallActionExecutionData,
        wabaDetails: wabaDetailsInterface | null,
        voiceCallDetails?: VoiceCallDetails | null,
    }) => void,
    openInboundCallPopupFromNotification: () => void,
    clearInboundCallState: () => void,
}

export const useVoiceCallStore = create<voiceCallStoreInterface>((set, get) => ({

    isVoiceCallingEnableWaba: false,
    setIsVoiceCallingEnableWaba: (value: boolean) => set({ isVoiceCallingEnableWaba: value }),

    flagVoiceCallPopup: false,
    setFlagVoiceCallPopup: (value: boolean) => set({ flagVoiceCallPopup: value }),

    flagVoiceCallInboundPopup: false,
    setFlagVoiceCallInboundPopup: (value: boolean) => set({ flagVoiceCallInboundPopup: value }),

    flagInboundCallNotification: false,
    setFlagInboundCallNotification: (value: boolean) => set({ flagInboundCallNotification: value }),

    callingWabaDetails: null,
    setCallingWabaDetails: (value: wabaDetailsInterface | null) => set({ callingWabaDetails: value }),

    callingPersonDetails: null,
    setCallingPersonDetails: (value: currentActiveChatbotThreadTypeNew | null) => set({ callingPersonDetails: value }),

    inboundCallExecutionData: null,
    setInboundCallExecutionData: (value: voiceCallActionExecutionData | null) => set({ inboundCallExecutionData: value }),

    voiceCallDetails: null,
    setVoiceCallDetails: (value: VoiceCallDetails | null) => set({ voiceCallDetails: value }),

    flagAutoAcceptInboundCall: false,
    setFlagAutoAcceptInboundCall: (value: boolean) => set({ flagAutoAcceptInboundCall: value }),

    isCallConnected: false,
    setIsCallConnected: (value: boolean) => set({ isCallConnected: value }),

    voiceCallId: "",
    setVoiceCallId: (value: string) => set({ voiceCallId: value }),

    isCalling: false,
    setIsCalling: (value: boolean) => set({ isCalling: value }),

    callDuration: 0,
    setCallDuration: (value: number) => set({ callDuration: value }),

    timerIntervalTimeout: null,
    setTimerIntervalTimeout: (value: NodeJS.Timeout | null) => set({ timerIntervalTimeout: value }),

    callStartTimeRef: null,
    setCallStartTimeRef: (value: number | null) => set({ callStartTimeRef: value }),

    startCallTimer: () => {
        const timerIntervalTimeout = get().timerIntervalTimeout;
        const setCallStartTimeRef = get().setCallStartTimeRef;
        const setTimerIntervalTimeout = get().setTimerIntervalTimeout;

        const startTime = Date.now();
        setCallStartTimeRef(startTime);

        if (timerIntervalTimeout) {
            clearInterval(timerIntervalTimeout);
        }

        let timerInterval = setInterval(() => {
            const elapsed = Math.floor((Date.now() - startTime) / 1000);
            set({ callDuration: elapsed });
        }, 1000);

        setTimerIntervalTimeout(timerInterval);
    },

    stopCallTimer: () => {
        const timerIntervalTimeout = get().timerIntervalTimeout;
        const setTimerIntervalTimeout = get().setTimerIntervalTimeout;
        const setCallStartTimeRef = get().setCallStartTimeRef;
        const setCallDuration = get().setCallDuration; 
        
        if (timerIntervalTimeout) {
            clearInterval(timerIntervalTimeout);
            setTimerIntervalTimeout(null);
        }
        setCallStartTimeRef(null);
        setCallDuration(0);
    },

    showInboundCallNotification: ({ callData, executionData, wabaDetails, voiceCallDetails = null }) => set({
        flagVoiceCallPopup: false,
        flagVoiceCallInboundPopup: false,
        flagInboundCallNotification: true,
        callingWabaDetails: wabaDetails,
        callingPersonDetails: callData,
        inboundCallExecutionData: executionData,
        voiceCallDetails,
        flagAutoAcceptInboundCall: false,
    }),

    openInboundCallPopupFromNotification: () => set({
        flagVoiceCallInboundPopup: true,
        flagInboundCallNotification: false,
        flagAutoAcceptInboundCall: true,
    }),

    clearInboundCallState: () => set({
        flagVoiceCallInboundPopup: false,
        flagInboundCallNotification: false,
        inboundCallExecutionData: null,
        voiceCallDetails: null,
        flagAutoAcceptInboundCall: false,
    }),
}))